// CustomTooltip.tsx

import { Tooltip, TooltipProps } from '@material-ui/core'
import React, { useState } from 'react'

const CustomTooltip: React.FC<TooltipProps> = ({
  title,
  children,
  ...props
}) => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Tooltip
      {...props}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      title={
        <div
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
          style={{ pointerEvents: 'auto' }}>
          {title}
        </div>
      }>
      <span
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        onClick={() => setOpen((prev) => !prev)} // handle mobile tap
        style={{ display: 'inline-flex' }}>
        {children}
      </span>
    </Tooltip>
  )
}

export default CustomTooltip
